import gql from 'graphql-tag';

const GET_LIST = gql`
  query GetList(
    $id: String!
    $countryCode: String!
    $currencyCode: CurrencyCode!
    $market: String
    $page: ListItemsPageInput
    $sort: ListItemsSort
    $order: AscDescOrderInput
  ) {
    list(id: $id) {
      id
      name
      public
      items(page: $page, sort: { by: $sort, order: $order }) {
        pageInfo {
          index
          limit
          total
        }
        edges {
          node {
            id
            product {
              id
              title
              urlKey
              name
              media {
                thumbUrl
              }
            }
            traits {
              size
              sizeDescriptor
            }
            market(currencyCode: $currencyCode) {
              state(country: $countryCode, market: $market) {
                lowestAsk {
                  amount
                }
                highestBid {
                  amount
                }
              }
              statistics(market: $market) {
                lastSale {
                  amount
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default GET_LIST;
